<template>
  <div class="form-group">
    <label class="col-xs-3" :for="name">{{ label }}:</label>
    <div class="col-xs-9">
      <input  class="form-control"
              :type="type"
              :id="name"
              :name="name"
              :placeholder="placeholder"
              @input="updateValue($event.target.value)"
              :value="value">
      <span class="text-danger" v-if="error" v-text="error"></span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: { required: true },
      label: { required: false },
      value: { required: false },
      error: { required: false },
      type: { required: false },
      placeholder: { required: false },
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value);
      }
    },
    mounted() {}
  }
</script>
